export default __webpack_public_path__ + "static/media/icon-settings.67a9ce5e.svg";